import React, { useContext } from 'react';
import { Link, Navigate } from 'react-router-dom';
import { AuthContext } from '../../components/AuthWrapper';

const AdminDashboard = () => {
  const { isAdmin } = useContext(AuthContext);

  // Redirect if not an admin
  if (!isAdmin) {
    return <Navigate to="/" />;
  }

  return (
    <div className="container mx-auto py-8 px-4">
      <h1 className="text-3xl font-bold mb-8 text-navy">Admin Dashboard</h1>
      
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        <DashboardCard 
          title="Timeline Management" 
          description="Add, edit or delete timeline events"
          link="/admin/timeline"
          icon="📅"
        />
        
        <DashboardCard 
          title="Exhibits Management" 
          description="Manage case exhibits, documents and evidence"
          link="/admin/exhibits"
          icon="📁"
        />
        
        <DashboardCard 
          title="Audio Transcripts" 
          description="Upload and manage audio files and transcripts"
          link="/admin/audio-transcripts"
          icon="🎙️"
        />
        
        <DashboardCard 
          title="Legal Claims" 
          description="Edit legal claims and arguments"
          link="/admin/legal-claims"
          icon="⚖️"
        />
        
        <DashboardCard 
          title="Letters & Affidavits" 
          description="Manage correspondence and sworn statements"
          link="/admin/letters-affidavits"
          icon="📝"
        />
        
        <DashboardCard 
          title="User Management" 
          description="Manage access tokens and permissions"
          link="/admin/users"
          icon="👥"
        />
        
        <DashboardCard 
          title="Data Migration" 
          description="Import/export data between JSON and Firebase"
          link="/admin/data-migration"
          icon="🔄"
        />
        
        <DashboardCard 
          title="Direct Import" 
          description="Directly import bundled JSON data to Firebase"
          link="/admin/import"
          icon="📥"
        />
      </div>
    </div>
  );
};

const DashboardCard = ({ title, description, link, icon }) => {
  return (
    <Link to={link} className="block">
      <div className="bg-white rounded-lg shadow-md p-6 hover:shadow-lg transition-shadow">
        <div className="text-4xl mb-4">{icon}</div>
        <h3 className="text-xl font-semibold mb-2 text-navy">{title}</h3>
        <p className="text-gray-600">{description}</p>
      </div>
    </Link>
  );
};

export default AdminDashboard;